import React, { useState, useEffect } from 'react'
import useCallApi from '../../../../hooks/useCallApi'
import { Line } from 'react-chartjs-2'
import Loading from '../../../../templates/UI/Loading/Loading'

export default function AffiliatesByPrioritySummary({ showSystemMessage }) {
    const { data, dataLoaded } = useCallApi(`reports/sotu`, 'GET', {}, [], showSystemMessage)

    return (
        <div className="card mb-2">
            <div className="card-header">Affiliates By Priority</div>
            <div style={{ height: '202px' }}>
                {dataLoaded ? (
                    <Line
                        data={{
                            labels: data.report.map((quarter) => quarter.quarter).reverse(),
                            datasets: [
                                {
                                    label: 'High',
                                    data: data.report.map((quarter) => quarter.aff_priority1_count).reverse(),
                                    fill: false,
                                    backgroundColor: 'rgb(22, 95, 205)',
                                    borderColor: 'rgb(22, 95, 205)',
                                },
                                {
                                    label: 'Medium',
                                    data: data.report.map((quarter) => quarter.aff_priority2_count).reverse(),
                                    fill: false,
                                    backgroundColor: 'rgb(242, 101, 20)',
                                    borderColor: 'rgb(242, 101, 20)',
                                },
                                {
                                    label: 'Low',
                                    data: data.report.map((quarter) => quarter.aff_priority4_count).reverse(),
                                    fill: false,
                                    backgroundColor: 'rgb(255, 205, 0)',
                                    borderColor: 'rgb(255, 205, 0)',
                                    hidden: true,
                                },
                                {
                                    label: 'Very Low',
                                    data: data.report.map((quarter) => quarter.aff_priority5_count).reverse(),
                                    fill: false,
                                    backgroundColor: 'rgb(239,0,255)',
                                    borderColor: 'rgb(239,0,255)',
                                    hidden: true,
                                },
                                {
                                    label: 'New',
                                    data: data.report.map((quarter) => quarter.aff_priority3_count).reverse(),
                                    fill: false,
                                    backgroundColor: 'rgb(35,193,120)',
                                    borderColor: 'rgb(35,193,120)',
                                    hidden: true,
                                },
                            ],
                        }}
                        options={{
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            beginAtZero: true,
                                        },
                                    },
                                ],
                            },
                            legend: {
                                display: true,
                                position: 'bottom',
                            },
                        }}
                        height={100}
                    />
                ) : (
                    <Loading />
                )}
            </div>
        </div>
    )
}
